module.exports = __webpack_public_path__ + "static/media/ice-tomato-sparkling.fec968b0.png";